import { Button, Image, Tooltip, message } from "antd";
import classNames from "classnames";
import styles from "./index.less";
import { ReactComponent as CopyIcon } from "../../assets/copy2.svg";
import { copyData } from "@packages/utils";
import { ChatMessageType } from "../types";
import CardMessage from "../messages/CardMessage";
import FileMessage from "../messages/File";
import VoiceMessage from "../messages/VoiceMessage";
import MiniProgramMessage from "../messages/MiniprogramMessage";

type ChatItemAIProps = {
  msg: ChatMessageType;
  onDelete: () => void;
};

const ChatItemAI = ({ msg }: ChatItemAIProps) => {
  function renderMsg() {
    switch (msg.type) {
      case "text":
        return msg.messageOutput;
      case "card":
        return <CardMessage msg={msg} />;
      case "image":
        return <Image src={msg.url} className={styles.img} />;
      case "file":
        return <FileMessage msg={msg} />;
      case "video":
        return <video src={msg.url} controls className={styles.video} />;
      case "voice":
        return <VoiceMessage url={msg.url} />;
      case "miniProgram":
        return <MiniProgramMessage msg={msg} />;
      default:
        return null;
    }
  }

  return (
    <div className={classNames(styles["chat-item-ai"], styles["chat-item"])}>
      <div className={styles["message-box"]}>
        <div className={styles["chat-item-ai-content"]}>
          <div className={styles["chat-text"]}>{renderMsg()}</div>
        </div>
        {msg.type === "text" && (
          <div className={styles["action-area"]}>
            <div className={styles.action}>
              <Tooltip title="复制" placement="bottom">
                <Button
                  type="text"
                  icon={<CopyIcon />}
                  onClick={async () => {
                    await copyData(msg.messageOutput);
                    message.success("复制成功");
                  }}
                />
              </Tooltip>
              {/* <div className={styles['action-divier']} /> */}
              {/* <Button type="text" icon={<DeleteIcon />} onClick={onDelete} /> */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatItemAI;
